import React from "react";
import { PageContainerWrap, PageContainerScroll } from "./PageContainer.style";

/**
 * Common container with glassmorphism effect. Container does not scroll; inner content scrolls.
 */
export default function PageContainer({ children, className, ...rest }) {
  const isWelcome = className?.includes("page-container-welcome");
  return (
    <PageContainerWrap className={className} {...rest}>
      {isWelcome ? children : <PageContainerScroll>{children}</PageContainerScroll>}
    </PageContainerWrap>
  );
}
